// This generated cookie string that encapsulate experiment bucket information of user to be
// persisted in cookies for later access.
export const generateCookieStringForExperimentBucket = (experimentBucketRows: any) => {
  let cookieString = ''
  experimentBucketRows?.forEach?.((row: any, index: number) => {
    cookieString = cookieString + row.name + '_' + row.date + '_' + row.bucket + '_' + row.expiryTime
    if (index < experimentBucketRows.length - 1) {
      cookieString = cookieString + '___'
    }
  })
  return cookieString
}

export const getExperimentDetailsFromCookieString = (expBucketString: string) => {
  const expBucketSplit = expBucketString.split('_')
  const expiryTime = expBucketSplit.pop()
  const expBucket = expBucketSplit.pop()
  const expDate = expBucketSplit.pop()
  const expName = expBucketSplit.join('_')
  return {
    expName,
    expDate,
    expBucket,
    expiryTime,
  }
}
